import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthHelper, AuthUser } from '@messaia/cdk';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {

	/**
	 * Constructor
	 * @param router 
	 */
	constructor(private oidcSecurityService: OidcSecurityService, private router: Router) { }

	/**
	 * Checks if the route can be activated
	 * @param next 
	 * @param state 
	 */
	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		if (this.isLoggedIn().subscribe()) {
			if (!this.isPermitted(AuthHelper.user, next.data["permissions"])) {
				this.router.navigate(['/forbidden']);
			}

			return true;
		}

		return false;
	}

	/**
	 * Checks if the user has the specified permission
	 * @param permission The permission to check
	 */
	public isPermitted(user: AuthUser, permissions: string[]): boolean {
		/* Admins have full access */
		permissions.push('Admin');
		permissions.push('Administrator');

		if (user && Array.isArray(user.permission)) {
			return permissions.some(permission => {
				return user.permission.indexOf(permission) >= 0;
			});
		}

		return false;
	}

	/**
	 * Checks if the user is logged in
	 */
	private isLoggedIn(): Observable<boolean | UrlTree> {
		return this.oidcSecurityService.isAuthenticated$.pipe(
			map(({ isAuthenticated }) => {
				/* Allow navigation if authenticated */
				if (isAuthenticated) {
					return true;
				}

				/* Redirect if not authenticated */
				return this.router.parseUrl('/unauthorized');
			})
		);
	}
}